import { render, staticRenderFns } from "./main_report.vue?vue&type=template&id=4679b379&scoped=true"
import script from "./main_report.vue?vue&type=script&lang=js"
export * from "./main_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679b379",
  null
  
)

export default component.exports